import { objectWithoutProperties as _objectWithoutProperties } from '../../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { TabPanels as TabPanels$1 } from '@reach/tabs';

var _excluded = ["isVertical", "children"];
var TabPanels = function TabPanels(props) {
  props.isVertical;
    var children = props.children,
    whiteListedProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(TabPanels$1, whiteListedProps, children);
};
var TabPanelsComponent = TabPanels;

export { TabPanelsComponent as default };
//# sourceMappingURL=TabPanels.js.map
